export const COUPON = {
    VALID: "valid",
    INVALID: "invalid",
};
